import * as React from 'react';

export const DefaultSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><g fill="#fff" stroke="#9e9e9e" strokeWidth="2"><rect width="22" height="22" rx="4" stroke="none"/><rect x="1" y="1" width="20" height="20" rx="3" fill="none"/></g></svg>
  );
};
